import { usePosthog } from '../use-posthog'

enum EventList {
  LIST_ADD_PROPERTY_ACTION = 'lists_add_property_action'
}

export const useEventList = () => {
  const { trackEvent } = usePosthog()

  const listAddPropertyAction = (
    where: 'list' | 'inventory' | 'leads' | 'search' | 'datasheet'
  ) => {
    trackEvent({
      name: EventList.LIST_ADD_PROPERTY_ACTION,
      eventProperties: {
        displayName: 'Agregar propiedad a lista',
        where
      }
    })
  }

  return {
    listAddPropertyAction
  }
}
